var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { IconButton, Stack } from '@fluentui/react';
import React from 'react';
//import NonProjectAddComponent from '../NonProjectAddComponent/NonProjectAddComponent';
import { NPAggregateRowCellStyle, NPAggregateRowHeaderStyle, NPChevronStyle } from './GridGroupHeaderComponent.styles';
// Define the component
function GridGroupHeaderComponent({ groupHeading, groupLength, groupValues, isPastView, onToggleCollapse, group, isCollapsed }) {
    const emojiIcon = {
        iconName: isCollapsed ? 'ChevronRight' : 'ChevronDown',
        color: '#605E5C'
    };
    return (React.createElement("div", { role: "row", style: {
            display: 'flex',
            flexDirection: 'row',
            borderBottom: '1px solid lightgrey',
            alignItems: 'center',
        } },
        React.createElement("div", { role: "gridcell" },
            React.createElement(IconButton, { styles: NPChevronStyle, onClick: () => onToggleCollapse(group), iconProps: emojiIcon, checked: false, ariaLabel: `${groupHeading}` })),
        React.createElement(Stack, { horizontal: true, verticalAlign: 'center' },
            React.createElement(Stack.Item, { styles: NPAggregateRowHeaderStyle },
                React.createElement("div", { role: "gridcell", style: { display: 'flex', justifyContent: 'space-between', alignContent: 'center' } },
                    React.createElement("h3", { style: { fontWeight: 600, fontSize: '14px' } },
                        groupHeading,
                        " (",
                        groupLength,
                        ")"),
                    !isPastView && groupHeading === 'Overhead Non-Project Hours')),
            group.isCollapsed &&
                groupValues &&
                groupValues.map((item, index) => (React.createElement(Stack.Item, { key: index, styles: NPAggregateRowCellStyle },
                    React.createElement("span", { style: item > 8 ? { color: 'red', fontWeight: 600 } : {} }, item)))))));
}
;
export default GridGroupHeaderComponent;
//# sourceMappingURL=GridGroupHeaderComponent.js.map